import { useMemo } from 'react';

import { useGetTimezonesQuery } from 'store/dictionaries/examinerDictionariesApi';

export function useTimezonesOptions() {
  const { data } = useGetTimezonesQuery();

  const options = useMemo(
    () =>
      data?.map((tz) => ({
        text: tz.name,
        value: tz.id,
      })) ?? [],
    [data]
  );

  return options;
}
